import { useContext } from 'react'

import { LogsContext } from './LogsContext'

export const useLogsContext = () => useContext(LogsContext)
